<dialog-draggable-header>Add Source</dialog-draggable-header>

<div class="add-modal-content" style="width: 520px">
    <div *ngIf="this.loading" class="loading-overlay"><span class="k-icon k-i-loading"></span></div>

    <form [formGroup]="form" class="container">
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Source Name" oninput="this.value = this.value.toUpperCase()"
                    formControlName="sourceName" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 1" formControlName="userSourceContactEmail1" />
            </mat-form-field>
        </div>
        <div class="row">
        </div>
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Code" formControlName="code" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 2" formControlName="userSourceContactEmail2" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Design Source Email 1" formControlName="contactEmail" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 3" formControlName="userSourceContactEmail3" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Design Source Email 2" formControlName="contactEmail2" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 4" formControlName="userSourceContactEmail4" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Design Source Email 3" formControlName="contactEmail3" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 5" formControlName="userSourceContactEmail5" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Design Source Email 4" formControlName="contactEmail4" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 6" formControlName="userSourceContactEmail6" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="Design Source Email 5" formControlName="contactEmail5" />
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-6">
                <input matInput placeholder="User Source Email 7" formControlName="userSourceContactEmail7" />
            </mat-form-field>
        </div>

        <div class="row">
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="inside" disableRipple>
                Inside?
            </mat-checkbox>
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="constSource" disableRipple>
                Construction Source?
            </mat-checkbox>
        </div>
        <div class="row">
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="outside" disableRipple>
                Outside?
            </mat-checkbox>
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="designSource" disableRipple>
                Design Source?
            </mat-checkbox>
        </div>
        <div class="row">
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="cadence" disableRipple>
                Cadence?
            </mat-checkbox>
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="userSource" disableRipple>
                User Source?
            </mat-checkbox>
        </div>
        <div class="row">
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="active" disableRipple>
                Active?
            </mat-checkbox>
            <mat-checkbox color="primary" class="col my-0 checkbox-format" formControlName="firstUserSource"
                disableRipple>
                First User Source?
            </mat-checkbox>
        </div>
    </form>
    <div #actions mat-dialog-actions class="cgp-dialog-actions">
        <span class="cgp-flex-fill"></span>
        <button color="primary" mat-raised-button [disabled]="!this.form.valid" (click)="onSaveClick()"
            (keydown.enter)="onSaveClick()">
            Save
        </button>
        <button mat-raised-button [disabled]="this.loading" (click)="close()" (keydown.enter)="close()">
            Cancel
        </button>
    </div>
</div>